import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmMessageModalContext } from '../confirm-message-modal/confirm-message-modal.component';
import { AppState } from '@app/app.service';
import { ModalHelper } from '@services/modal-helper.service';
import { AccountPaymentProfile, DeviceContextService, IUserProfile, PaymentProfile, PaymentsService, ProfileService } from '@ztarmobile/zwp-service-backend-v2';
import { BRAND } from '@app/app.config';
import { ToastrHelperService } from '@services/toast-helper.service';

export type AddPaymentModalData = {
  user: IUserProfile,
  customClass?: string,

}

@Component({
  selector: 'app-add-payment-card-modal',
  templateUrl: './add-payment-card-modal.component.html',
  styleUrl: './add-payment-card-modal.component.scss'
})
export class AddPaymentCardModalComponent {
  public businessName = BRAND;
  public componentDesc = {
    title: 'Billing address',
    info: 'Please select your billing address information, or add a new one:',
    sameAsShipping: 'Same as shipping address',
    anotherAddress: 'Use Another Address',
    cancelButton: 'Cancel',
    saveButton: 'Save',
    proceedButton: 'Proceed',
    locationImgPath: 'assets/img/location.svg',
    hint: '<p class="caption"><b>Hint:</b> Enter Full Name as it’s written on the card.</p>'
  }

  private confirmationToken: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AddPaymentModalData,
    public dialog: MatDialogRef<ConfirmMessageModalContext>,
    private modalHelper: ModalHelper,
    private appState: AppState,
    private paymentService: PaymentsService,
    private toastHelper: ToastrHelperService,
    private deviceService: DeviceContextService
  ) { }

  public createPaymentProfile(): void {
    const body: PaymentProfile = {
      accountId: this.data.user?.customerId,
      confirmationToken: this.confirmationToken,
      profileType: 'card',
      device : this.deviceService.getDeviceContext()
    }
    this.paymentService.createPaymentProfile(body).then((res) => {
      this.appState.loading = false;
      if (!!res) {
        Object.assign(res, { expired: false });
        const el = document.getElementById('credit-cards');
        el?.scrollIntoView();
        this.closeDialog(res);

        this.modalHelper.successModal(
          `${res?.card_profile?.brand?.toUpperCase()} ending in ${res?.card_profile?.last_4}`,
          'Done',
          'secondary-success-modal',
          'Card Successfully Added',
          '',
          'assets/icon/banner-success-icon.svg',
          true,
        );
      }
    }, (error) => {
      this.appState.loading = false;
      this.closeDialog();
      
      this.modalHelper.failureModal(
        error?.error?.errors[0]?.message,
        'Retry',
        'secondary-fail-modal',
        'Adding Card Failed',
        '',
        'assets/icon/error.svg'
      );
    });
  }

  public handleConfirmationToken(event): void {
    this.confirmationToken = event.id;
  }

  public handleLoading(event): void {
    this.appState.loading = event;
  }

  public handleAddressVerification(event, method?: AccountPaymentProfile): void {
      this.closeDialog();
      this.modalHelper.failureModal(
      'Double check your entered billing address or try another one.',
      'Got it',
      'secondary-fail-modal',
      'We Couldn’t Verify your Billing Address.',
      '',
      'assets/icon/error.svg'
    );
  }

  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  closeDialog(res?): void {
    this.beforeClose();
    this.dialog.close(res);
  }
}
